import React from "react";
import {
  View,
} from "react-native";
import TextField from "@material-ui/core/TextField";

import ShowPasswordButton from "./ShowPasswordButton";

export default class TextInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  handleTogglePassword = (visible) => {
    const isPasswordInput = this.props.keyboardType === "password";
    if (!isPasswordInput) {
      return;
    }
    this.setState({ showPassword: visible });
  };

  render() {
    const isPasswordInput = this.props.keyboardType === "password";
    return (
      <form className={this.props.style} noValidate autoComplete={this.props.isOTP ? "one-time-code" : (this.props.autoComplete ? "on" : "off") } onSubmit={e=>e.preventDefault()}>
        <View styles={{ weight: "100%", formsize: 1800 }}>
          <TextField
            placeholder={this.props.placeholder}
            onChange={(text) =>
              this.props.onChangeText &&
              this.props.onChangeText(text.target.value)
            }
            name={this.props.name}
            autoComplete={this.props.isOTP ? "one-time-code" : this.props.name}
            value={this.props.value}
            disabled={this.props.editable == false}
            maxlength={this.props.maxLength}
            type={!isPasswordInput ? this.props.keyboardType : (this.state.showPassword ? "text" : "password")}
            multiline={this.props.multiline}
            margin="auto"
            onKeyPress={(e) => e.key === "Enter" && e.preventDefault()}
            InputProps={{
              endAdornment: isPasswordInput && (
                <ShowPasswordButton onToggle={this.handleTogglePassword} />
              ),
            }}
          />
        </View>
      </form>
    );
  }
}
